import { makeElementCreator } from '@qdabra/build-xml';
import { compose, map, nth, sortBy, toLower, toPairs } from 'ramda';

const NS_USER_PROFILE =
    'http://microsoft.com/webservices/SharePointPortalServer/UserProfileService';

const userProfileElement = makeElementCreator(NS_USER_PROFILE, 'u');

// { String: String } -> [[String, String]]
const sortAndConvertProperties = compose(
    sortBy(compose(toLower, nth(0))),
    toPairs,
);

// (DOMDocument, String) -> DOMElement
const buildValueDataNode = (document, value) =>
    userProfileElement(document, 'ValueData', {
        children: [
            userProfileElement(document, 'Value', {
                text: value,
            }),
        ],
    });

// (DOMDocument) -> ([String, String]) -> DOMElement
const buildPropertyNode =
    (document) =>
    ([propertyName, value]) =>
        userProfileElement(document, 'PropertyData', {
            children: [
                userProfileElement(document, 'IsPrivacyChanged', {
                    text: 'false',
                }),
                userProfileElement(document, 'IsValueChanged', {
                    text: 'false',
                }),
                userProfileElement(document, 'Name', {
                    text: propertyName,
                }),
                userProfileElement(document, 'Privacy'),
                userProfileElement(document, 'Values', {
                    children: [buildValueDataNode(document, value)],
                }),
            ],
        });

// (DOMDocument, { String: String}) -> DOMElement
export const buildUserProfileResponseNode = (document, properties) => {
    const sortedProperties = sortAndConvertProperties(properties);

    return userProfileElement(document, 'GetUserProfileByNameResponse', {
        children: [
            userProfileElement(document, 'GetUserProfileByNameResult', {
                children: map(buildPropertyNode(document), sortedProperties),
            }),
        ],
    });
};
